export default __webpack_public_path__ + "static/contact_form_2-e361a8a8f641990dfaea9d1e528d1c67.png";